const isAlias = (value: unknown, separator: string): value is string =>
  typeof value === 'string' && value.includes(separator);

export default isAlias;
